import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MenuService } from 'src/app/shared/services/menu.service';
import { IMenu } from 'src/app/shared/responses/imenu';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as debug from 'src/app/shared/services/debug.service';

@Component({
	selector: 'app-favorites',
	templateUrl: './favorites.component.html',
	styleUrls: ['./favorites.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FavoritesComponent {

	@Input() menuItems: IMenu[];
	moduleUrlSegment: string;

	constructor(public menuService: MenuService,
		public readonly securityService: SecurityService,
		private cdr: ChangeDetectorRef
	) {
		this.securityService.loginChanged.subscribe(loggedIn => {
			debug.log(`074.2 FavoritesComponent loggedIn: ${loggedIn}`);
			this.cdr.detectChanges();
		});
	}

	get activeModule() {
		return this.menuService.activeModule;
	}

	setActiveModule(routerLink: string) {
		this.menuService.setActiveModule(routerLink, `FavoritesComponent.setActiveModule`);
	}
}
